import { BackendConfig, BackendProvider, IBackendAdapter } from './types'
import {
	PlaceOrModifyOrdersRequest,
	PlaceOrModifyOrdersResponse,
	GetAllOrdersRequest,
	CancelOrdersRequest,
	CancelOrdersResponse
} from '../proto/generated/trading-bridge'
import { Order } from '../proto/generated/order'
import { PositionRequest, PositionResponse } from '../proto/generated/position'
import {
	AuthProviderLoginUrlResponse,
	ForgetPasswordRequest,
	GetActiveSessionsResponse,
	LoginRequest,
	LoginResponse,
	OperationResponse,
	User,
	UserSignUpRequest,
	ValidateThirdPartyTokenRequest
} from '../proto/generated/identity'

export abstract class BaseAdapter implements IBackendAdapter {
	protected config: BackendConfig

	constructor(config: BackendConfig) {
		this.config = config
	}

	getProvider(): BackendProvider {
		return this.config.provider
	}

	getBaseUrl(): string {
		return this.config.baseUrl
	}

	getWebSocketUrl(): string {
		return this.config.wsUrl || this.config.baseUrl.replace('http', 'ws')
	}

	abstract transformRequest<T = any>(
		endpoint: string,
		data: T,
		method: string
	): {
		url: string
		data: any
		headers?: Record<string, string>
	}

	abstract transformResponse<T = any>(response: any, endpoint: string): T

	transformError(error: any): any {
		return {
			message: error?.message || 'An error occurred',
			code: error?.code || 'UNKNOWN_ERROR',
			status: error?.response?.status || 500,
			data: error?.response?.data
		}
	}

	protected getCustomHeaders(): Record<string, string> {
		return this.config.headers || {}
	}

	// Abstract order methods - must be implemented by concrete adapters
	abstract placeOrModifyOrder(request: PlaceOrModifyOrdersRequest): Promise<PlaceOrModifyOrdersResponse>
	abstract getOrders(request: GetAllOrdersRequest): Promise<Order[]>
	abstract cancelOrder(request: CancelOrdersRequest): Promise<CancelOrdersResponse>
	abstract getPositions(request: PositionRequest): Promise<PositionResponse>
	abstract getPlacedOrder(params: any): Promise<Order>

	// Abstract auth methods - must be implemented by concrete adapters
	abstract getLoginUrl(body: any): Promise<AuthProviderLoginUrlResponse>
	abstract loginWithMail(body: LoginRequest): Promise<LoginResponse>
	abstract signUpWithMail(userSignUpRequest: UserSignUpRequest): Promise<LoginResponse>
	abstract sendEmailOtp(email: string): Promise<any>
	abstract forgetPassword(body: ForgetPasswordRequest): Promise<User>
	abstract validateToken(body: ValidateThirdPartyTokenRequest): Promise<LoginResponse>

	abstract logout(): void
	abstract getActiveSessions(): Promise<GetActiveSessionsResponse>
	abstract revokeSession(deviceId: string): Promise<OperationResponse>
}
